export default __webpack_public_path__ + "static/media/girando_ollin.4eb6b83e.png";